/* eslint-disable react/no-children-prop */
import React from 'react';
import cn from 'classnames';
import { Disclosure } from '@headlessui/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import styles from './answer.module.css';

const FAQ = ({ title, overtitle, faqs }) => (
  <div className="grid gap-10 lg:gap-16 md:grid-cols-12">
    <div className="col-span-3 mb-10 lg:mb-0">
      {overtitle && <h2 className="inline-block mb-6 text-overtitle text-gradient">{overtitle}</h2>}
      <h3 className="mb-4 text-4xl text-white lg:text-5xl font-aeonik">{title}</h3>
    </div>
    <div className="col-span-9 border-b border-neutral-800">
      {faqs.map(faq => (
        <div id={faq?.id}>
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex items-center justify-between w-full py-4 text-lg text-left border-t border-neutral-800 gap-x-8 md:gap-x-20 sm:text-xl">
                  <span>{faq.question}</span>
                  <ChevronIcon
                    className={cn(
                      'transition-transform duration-150 ease-in-out shrink-0',
                      open ? 'transform rotate-180' : ''
                    )}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="pb-4 text-base text-neutral-300">
                  <ReactMarkdown
                    className={styles.answer}
                    children={faq.answer}
                    rehypePlugins={[rehypeRaw]}
                  />
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      ))}
    </div>
  </div>
);

const ChevronIcon = ({ className }) => (
  <svg className={className} width="14" height="18" viewBox="0 0 14 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.52802 17.0367C7.23547 17.3297 6.76083 17.33 6.46789 17.0374C6.46765 17.0372 6.46742 17.0369 6.46718 17.0367L0.840458 11.4072C0.54735 11.1142 0.547224 10.6391 0.840177 10.346C1.13313 10.0529 1.60823 10.0528 1.90133 10.3457L6.25381 14.7005V1.5083V1.5083C6.25381 1.09409 6.58959 0.758301 7.00381 0.758301C7.41802 0.758301 7.75381 1.09409 7.75381 1.5083V14.6878L12.0938 10.3457C12.3869 10.0528 12.862 10.0529 13.155 10.346C13.448 10.6391 13.4479 11.1142 13.1547 11.4072C13.1547 11.4072 13.1547 11.4072 13.1547 11.4072L7.52802 17.0367Z"
      fill="#D4D4D4"
    />
  </svg>
);

FAQ.defaultProps = {
  overtitle: false,
  title: 'FAQ',
  faqs: [
    {
      question: 'What task types are supported?',
      answer: `Scale Rapid supports general image annotation, 2D semantic segmentation, text collection, document transcription, named entity recognition, video playback annotation, and lidar annotation. More information regarding the task types can be found [here](https://www.youtube.com/watch?v=nEMuTC6_OWI&list=PLR8xSRbGJjJCN0BFGOYOXGfJbCmlx40c2&index=2). Text collection is a general task type where Scale can gather information from given attachments or web links. Example tasks could include creating a description from an attached image or querying website information given a link.`
    }
  ]
};

export default FAQ;
